import { render, staticRenderFns } from "./WsInfoFileItem.vue?vue&type=template&id=87e826e2"
import script from "./WsInfoFileItem.vue?vue&type=script&lang=js"
export * from "./WsInfoFileItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports